/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/DesignSystem/VerticalTimeline/VerticalTimelineForm/Name"
  
}) {
let timelineEventUserPersonFirstNameValueData = fromData.useDataValue({ viewPath,
context: 'timeline_event',
path: 'user.person.first_name',
})
let timelineEventUserPersonLastNameValueData = fromData.useDataValue({ viewPath,
context: 'timeline_event',
path: 'user.person.last_name',
})
let aggregateData = fromAggregate.join(timelineEventUserPersonFirstNameValueData, timelineEventUserPersonLastNameValueData)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 data="timeline_event.user.person.first_name"
 data="timeline_event.user.person.last_name"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}